const keys = [
  'composer.voiceCall', 'composer.videoCall', 'composer.videoCallUnavailable',
  'voiceCall.title', 'voiceCall.videoTitle', 'voiceCall.incoming', 'voiceCall.incomingVideo', 'voiceCall.calling', 'voiceCall.connecting',
  'voiceCall.active', 'voiceCall.ending', 'voiceCall.ended', 'voiceCall.declined',
  'voiceCall.cancelled', 'voiceCall.timeout', 'voiceCall.answeredElsewhere',
  'voiceCall.accept', 'voiceCall.acceptVideo', 'voiceCall.reject', 'voiceCall.cancel', 'voiceCall.hangUp',
  'voiceCall.mute', 'voiceCall.unmute', 'voiceCall.cameraOn', 'voiceCall.cameraOff', 'voiceCall.cameraDisabled', 'voiceCall.close', 'voiceCall.error', 'voiceCall.switchCamera'
];

const values = {
  zh_hans: [
    '语音通话', '视频通话', '视频通话暂未开放',
    '语音通话', '视频通话', '邀请你语音通话', '邀请你视频通话', '正在呼叫…', '正在连接…',
    '通话中', '正在结束…', '通话已结束', '对方拒绝了通话',
    '对方已取消通话', '无人接听', '对方已在其他设备接听',
    '接听', '接听视频', '拒绝', '取消呼叫', '挂断', '静音', '取消静音', '开启摄像头', '关闭摄像头', '摄像头已关闭', '关闭', '通话出错', '切换摄像头'
  ],
  zh_hant: [
    '語音通話', '視訊通話', '視訊通話尚未開放',
    '語音通話', '視訊通話', '邀請你語音通話', '邀請你視訊通話', '正在呼叫…', '正在連線…',
    '通話中', '正在結束…', '通話已結束', '對方拒絕了通話',
    '對方已取消通話', '無人接聽', '對方已在其他裝置接聽',
    '接聽', '接聽視訊', '拒絕', '取消呼叫', '掛斷', '靜音', '取消靜音', '開啟攝影機', '關閉攝影機', '攝影機已關閉', '關閉', '通話發生錯誤', '切換攝影機'
  ],
  en: [
    'Voice call', 'Video call', 'Video calls are not available yet',
    'Voice call', 'Video call', 'is calling you', 'is inviting you to a video call', 'Calling…', 'Connecting…',
    'In call', 'Ending…', 'Call ended', 'Call declined',
    'Call cancelled', 'No answer', 'Answered on another device',
    'Answer', 'Answer video', 'Decline', 'Cancel call', 'Hang up', 'Mute', 'Unmute', 'Turn camera on', 'Turn camera off', 'Camera is off', 'Close', 'Call error', 'Switch camera'
  ],
  km: [
    'ការហៅជាសំឡេង', 'ការហៅជាវីដេអូ', 'មិនទាន់មានការហៅជាវីដេអូទេ',
    'ការហៅជាសំឡេង', 'ការហៅជាវីដេអូ', 'កំពុងហៅអ្នក', 'កំពុងអញ្ជើញអ្នកឱ្យហៅជាវីដេអូ', 'កំពុងហៅ…', 'កំពុងភ្ជាប់…',
    'កំពុងហៅ', 'កំពុងបញ្ចប់…', 'បានបញ្ចប់ការហៅ', 'បានបដិសេធការហៅ',
    'បានលុបការហៅ', 'គ្មានអ្នកឆ្លើយ', 'បានទទួលនៅឧបករណ៍ផ្សេង',
    'ទទួល', 'ទទួលការហៅជាវីដេអូ', 'បដិសេធ', 'បោះបង់ការហៅ', 'បិទការហៅ', 'បិទមីក្រូហ្វូន', 'បើកមីក្រូហ្វូន', 'បើកកាមេរ៉ា', 'បិទកាមេរ៉ា', 'កាមេរ៉ាបិទ', 'បិទ', 'មានបញ្ហាក្នុងការហៅ', 'ប្តូរកាមេរ៉ា'
  ],
  lo: [
    'ໂທດ້ວຍສຽງ', 'ໂທດ້ວຍວິດີໂອ', 'ຍັງບໍ່ເປີດໃຫ້ໂທວິດີໂອ',
    'ໂທດ້ວຍສຽງ', 'ໂທດ້ວຍວິດີໂອ', 'ກຳລັງໂທຫາທ່ານ', 'ກຳລັງເຊີນທ່ານໃຫ້ໂທວິດີໂອ', 'ກຳລັງໂທ…', 'ກຳລັງເຊື່ອມຕໍ່…',
    'ກຳລັງສົນທະນາ', 'ກຳລັງຈົບ…', 'ຈົບການໂທແລ້ວ', 'ອີກຝ່າຍປະຕິເສດ',
    'ອີກຝ່າຍຍົກເລີກການໂທ', 'ບໍ່ມີຄົນຮັບ', 'ຮັບສາຍຢູ່ອຸປະກອນອື່ນ',
    'ຮັບສາຍ', 'ຮັບສາຍວິດີໂອ', 'ປະຕິເສດ', 'ຍົກເລີກການໂທ', 'ວາງສາຍ', 'ປິດສຽງ', 'ເປີດສຽງ', 'ເປີດກ້ອງ', 'ປິດກ້ອງ', 'ປິດກ້ອງແລ້ວ', 'ປິດ', 'ການໂທຂັດຂ້ອງ'
  ],
  th: [
    'โทรด้วยเสียง', 'วิดีโอคอล', 'ยังไม่เปิดให้ใช้วิดีโอคอล',
    'โทรด้วยเสียง', 'วิดีโอคอล', 'กำลังโทรหาคุณ', 'เชิญคุณเข้าร่วมวิดีโอคอล', 'กำลังโทร…', 'กำลังเชื่อมต่อ…',
    'กำลังสนทนา', 'กำลังวางสาย…', 'วางสายแล้ว', 'อีกฝ่ายปฏิเสธสาย',
    'อีกฝ่ายยกเลิกสาย', 'ไม่มีผู้รับสาย', 'รับสายในอุปกรณ์อื่นแล้ว',
    'รับสาย', 'รับวิดีโอคอล', 'ปฏิเสธ', 'ยกเลิกสาย', 'วางสาย', 'ปิดไมค์', 'เปิดไมค์', 'เปิดกล้อง', 'ปิดกล้อง', 'ปิดกล้องอยู่', 'ปิด', 'การโทรขัดข้อง', 'สลับกล้อง'
  ],
  vi: [
    'Gọi thoại', 'Gọi video', 'Cuộc gọi video chưa khả dụng',
    'Gọi thoại', 'Gọi video', 'đang gọi cho bạn', 'mời bạn gọi video', 'Đang gọi…', 'Đang kết nối…',
    'Đang trò chuyện', 'Đang kết thúc…', 'Cuộc gọi đã kết thúc', 'Cuộc gọi bị từ chối',
    'Cuộc gọi đã bị hủy', 'Không có người trả lời', 'Đã nhận trên thiết bị khác',
    'Trả lời', 'Trả lời video', 'Từ chối', 'Hủy cuộc gọi', 'Gác máy', 'Tắt mic', 'Bật mic', 'Bật camera', 'Tắt camera', 'Camera đang tắt', 'Đóng', 'Cuộc gọi gặp lỗi', 'Đổi camera'
  ]
};

export const voiceCallMessages = Object.fromEntries(Object.entries(values).map(([locale, words]) => [
  locale,
  Object.fromEntries(keys.map((key, index) => [key, words[index]]))
]));
